import { FilterOperation } from '@enums/filter.operation.enum';
import { ResultConstant } from '@enums/result-constant.enum';
import { TestCaseStatus } from '@testsigmainc/constants';
import { FilterQuery } from '@models/filter-query.model';
import { Base, PageObject } from '@testsigmainc/models';
import { custom, deserialize, serializable, serialize } from 'serializr';

export class TestCaseFilter extends Base implements PageObject {
  @serializable
  public id: number;
  @serializable
  public name: string;
  @serializable(
    custom(
      (v) => JSON.stringify(v),
      (v) => {
        const filter: FilterQuery[] = [];
        if (typeof v == 'string') v = JSON.parse(v);
        v.forEach((query) => {
          filter.push(new FilterQuery().deserialize(query));
        });
        return filter;
      },
    ),
  )
  public queryHash: FilterQuery[];
  @serializable
  public versionId: number;
  @serializable
  public isPublic: boolean;
  @serializable
  public isDefault: boolean;
  @serializable
  public createdById: number;
  @serializable
  public isMappedToTestSuite: boolean;

  public normalizedQuery: FilterQuery[];

  private normaliseCurrentValue(value, currentValue) {
    let returnValue = value;
    if (value instanceof Array) {
      returnValue = (<number[]>value).map((value) => {
        if (value == -1) return currentValue;
        else return value;
      });
    } else if (value == '-1') {
      returnValue = currentValue;
    }
    return returnValue;
  }

  normalizeCustomQuery(queryHash: string) {
    const normalizedQueryHash: FilterQuery[] = [];
    queryHash.split(',').forEach((query) => {
      if (query == '') return;
      const normalizedQuery = new FilterQuery();
      if (query.indexOf(':') > 0) {
        normalizedQuery.operation = FilterOperation.EQUALITY;
        normalizedQuery.key = query.split(':')[0];
        normalizedQuery.value = query.split(':')[1];
        if (
          normalizedQuery.key == 'isStepGroup' ||
          normalizedQuery.key == 'deleted' ||
          normalizedQuery.key == 'isManual' ||
          normalizedQuery.key == 'suiteMapping'
        ) {
          normalizedQuery.value = query.split(':')[1] != 'false';
        } else if (normalizedQuery.key.indexOf('cf_') != 0)
          normalizedQuery.value = <number>Number(query.split(':')[1]);
      } else if (query.indexOf('@') > 0) {
        normalizedQuery.operation = FilterOperation.IN;
        normalizedQuery.key = query.split('@')[0];
        normalizedQuery.value = query.split('@')[1].split('#');
        if (normalizedQuery.key == 'status')
          normalizedQuery.value = normalizedQuery.value.map(
            (v) => <TestCaseStatus>v,
          );
        else if (normalizedQuery.key == 'result')
          normalizedQuery.value = normalizedQuery.value.map(
            (v) => <ResultConstant>v,
          );
        else if (normalizedQuery.key.indexOf('cf_') == 0)
          normalizedQuery.value = normalizedQuery.value.map((v) => v);
        else
          normalizedQuery.value = normalizedQuery.value.map((v) => parseInt(v));
      } else if (query.indexOf('>') > 0) {
        normalizedQuery.operation = FilterOperation.GREATER_THAN;
        normalizedQuery.key = query.split('>')[0];
        normalizedQuery.value = query.split('>')[1];
      } else if (query.indexOf('<') > 0) {
        normalizedQuery.operation = FilterOperation.LESS_THAN;
        normalizedQuery.key = query.split('<')[0];
        normalizedQuery.value = query.split('<')[1];
      }
      normalizedQueryHash.push(normalizedQuery);
    });
    this.normalizedQuery = normalizedQueryHash;
  }

  normalizeQuery(versionId: number, loggedInUserId: number): void {
    const normalizedQueryHash: FilterQuery[] = [];
    this.queryHash.forEach((query) => {
      const newQuery = new FilterQuery();
      newQuery.key = query.key;
      newQuery.operation = query.operation;
      if (query.key == 'applicationVersionId') {
        query.value = this.normaliseCurrentValue(query.value, versionId);
      } else if (query.key == 'reviewedBy' || query.key == 'assignee') {
        query.value = this.normaliseCurrentValue(query.value, loggedInUserId);
      }
      newQuery.value = query.value;
      normalizedQueryHash.push(newQuery);
    });
    this.normalizedQuery = normalizedQueryHash;
  }

  deserialize(input: any): this {
    return Object.assign(this, deserialize(TestCaseFilter, input));
  }

  public serialize(): JSON {
    return serialize(this);
  }
}
